"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Field = _interopRequireDefault(require("../Field/Field"));

var _Textarea = _interopRequireDefault(require("../Textarea/Textarea"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CommentEdit = function CommentEdit(_ref) {
  var id = _ref.id,
      value = _ref.value,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      onClickCancel = _ref.onClickCancel,
      onClickSubmit = _ref.onClickSubmit,
      submitting = _ref.submitting,
      validationMessage = _ref.validationMessage;
  return (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)(_Field["default"], null, (0, _themeUi.jsx)(_Textarea["default"], {
    id: id,
    validationMessage: validationMessage,
    disabled: submitting,
    onChange: onChange,
    onKeyDown: onKeyDown,
    value: value,
    sx: {
      resize: 'vertical'
    }
  })), (0, _themeUi.jsx)("div", {
    sx: {
      "float": 'right'
    }
  }, (0, _themeUi.jsx)(_Button["default"], {
    disabled: submitting,
    onClick: onClickCancel,
    variant: "text"
  }, "CANCEL"), (0, _themeUi.jsx)(_Button["default"], {
    loading: submitting,
    onClick: onClickSubmit,
    sx: {
      ml: 2
    }
  }, "SAVE")));
};

CommentEdit.propTypes = {
  id: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onClickCancel: _propTypes["default"].func,
  onClickSubmit: _propTypes["default"].func,
  submitting: _propTypes["default"].bool,
  validationMessage: _propTypes["default"].string
};
var _default = CommentEdit;
exports["default"] = _default;